<template lang="html">
  <div class="homePage" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back1.png` +')'}">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>
    
    <div class="content">
      <div class="conBtn">
        <div class="liveStreamingBtn" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button1.png` +')'}" @click="golive">
          观看直播
        </div>
        <div class="giftBtn" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button2.png` +')'}" @click="goGift">
          <img :src="`${pagebase}/static/img/assistance/icon.png`" alt="">
          免费领实物礼品
        </div>
      </div>
    </div>

    <div class="loginCard" v-show="loginCardShow" @click.self="loginCardShow = false">
      <div class="loginCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back11.png` +')'}">
        <input type="number" class="phoneInput" placeholder="请输入手机号领奖品" name="phoneInput" v-model="phone">
        <div class="securityCodeInput">
          <input type="text" placeholder="小小验证码" name="securityCode" v-model="smsCode">
          <p @click="getSmsCode">{{buttonMsg}}</p>
        </div>

        <div class="beginBtn" @click="goLogin">
          开始
        </div>
      </div>
    </div>
    
    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import {
    pagebase
  } from '@/utils/http.js';
  import '@/utils/rem'
  import Cookies from 'js-cookie';
  export default {
    data() {
      return {
        aid: '',
        pagebase: pagebase,
        loginCardShow: false,
        activityUrl: '',
        getInfo: false,
        informerShow: 0,

        phone: '',
        smsCode: '',
        limitTime: 60,
        buttonMsg: '发送验证码',
      }
    },
    
    components: {
      
    },

    mounted() {
      this.getLiveUrl();
    },

    methods: {
      // 获取直播地址
      getLiveUrl(){
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityUrl = res.data.live_url;
            if(Cookies.get('uid') && Cookies.get('token')){
              this.getInfo = true;
            } else {
              this.getInfo = false;
            }
          }
        })
      },
      
      // 跳转小鹅通直播间
      golive(){
        if(Cookies.get('uid') && Cookies.get('token')){
          window.location.href = 'https://appZtx88lAc9991.h5.xiaoeknow.com/v2/course/alive/l_6385af54e4b0fc5d120c2807?app_id=appZtx88lAc9991&alive_mode=0&pro_id=&type=2';
        } else {
          this.loginCardShow = true;
        }
      },

      // 跳转奖品页
      goGift() {
        if(Cookies.get('uid') && Cookies.get('token')){
          this.$router.push({
            path: '/assistancesInvite',
            query:{
              activityId: this.$route.query.activityId,
            }
          })
        } else {
          this.loginCardShow = true;
        }
      },

      // 获取验证码
      getSmsCode() {
        this.$http.get('/Registered/getPhoneSmsCode', {
          params: utils.cso({
            phone: this.phone,
            phone_head: 86,
            type: 10,
            client: 'H5'
          })
        }).then((res) => {
          if (res.code >= 0) {
            this.buttonMsg = this.limitTime + 's'
            this.timer = window.setInterval(() => {
              this.limitTime--
              this.buttonMsg = this.limitTime + 's'
              if (this.limitTime < 0) {
                window.clearInterval(this.timer)
                this.buttonMsg = '发送验证码'
                this.limitTime = 60
              }
            }, 1000)
          } else {
            utils.showMessage(res.msg)
          }
        })
      },

      // 确定登录
      goLogin() {
        if (this.phone) {
          if (this.smsCode) {
            this.$http({
              url: '/member/joinActivity',
              method: 'post',
              params: {
                phone: this.phone,
                sms_code: this.smsCode,
                type: 0,
                live_activity_id: this.$route.query.activityId,
              },
            }).then((res) => {
              if (res.code >= 0) {
                Cookies.set('uid', res.data.uid);
                Cookies.set('token', res.data.token.token);
                Cookies.set('reg_channel', res.data.reg_channel);
                Cookies.set('aid', res.data.activity_reg_id);
                Cookies.set('phone', this.phone);
                this.loginCardShow = false;
                this.getLiveUrl();
              } else {
                utils.showMessage(res.msg)
              }
            })
          } else {
            utils.showMessage('输入的验证码不能为空')
          }
        } else {
          utils.showMessage('输入的手机号不能为空')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .homePage {
    box-sizing: border-box;
    width: 100%;
    height: 76.5rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #000000;
    position: relative;
    padding: 0 1.2rem;
  }
  
  .informerBtn {
    position: absolute;
    top: 1.5rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }
  
  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #06314e;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 1.2rem;
    padding-bottom: 1.9rem;
  }

  .conImg {
    width: 100%;
  }

  .conBtn {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }

  .liveStreamingBtn {
    position: relative;
    width: 43%;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #642207;
  }

  .giftBtn {
    width: 53%;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #642207;
  }

  .giftBtn img {
    width: 1.75rem;
    margin-right: .4rem;
  }

  /* 登录 */
  .loginCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loginCon {
    width: 31rem;
    height: 43.3rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .phoneInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
    margin-bottom: 1.4rem;
  }

  .phoneInput[name="phoneInput"]::-webkit-input-placeholder {
    color: #642207;
  }

  .securityCodeInput {
    display: flex;
    height: 4.7rem;
    margin-bottom: 4.3rem;
  }

  .securityCodeInput input {
    width: 65%;
    border-radius: 4.7rem 0 0 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
  }

  .securityCodeInput p {
    width: 35%;
    border-radius: 0 4.7rem 4.7rem 0;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    color: #F7443F;
    padding-right: 2rem;
  }

  .securityCodeInput input[name="securityCode"]::-webkit-input-placeholder {
    color: #642207;
  }

  .beginBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    background: linear-gradient(170deg, #FFDB9E, #FF9F55);
    margin-bottom: 3.65rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #642207;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  
  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }
  
  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }
</style>
